// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YhO1P","label":"styles_label__2OG8h"};